import ApiUtils from "../utils/ApiUtils"
import {IRamsayApis} from "./IRamsayApis";
import IFoodCategory from "../models/IFoodCategory";
import IMealItem from "../models/IMealItem";
import IFetchMealsByCaloriesRequest from "../models/IFetchMealsByCaloriesRequest";
import {MEAL_SERVICE_API_KEY, MEAL_SERVICE_API_PREFIX, RAMSAY_API_PREFIX} from "../../../common/configs/configs";

const foodGroupsUrl: string = RAMSAY_API_PREFIX + "/model/ingredientCategories";
const fetchMealsByCalorieUrl: string = MEAL_SERVICE_API_PREFIX + "/filter";
const getMealByMealId: string = MEAL_SERVICE_API_PREFIX + "/meal?mealId=$mealId";
const previewMeal: string = MEAL_SERVICE_API_PREFIX + "/meal/preview";
const createMeal: string = MEAL_SERVICE_API_PREFIX + "/meal/unapproved";
const getMealsByIdsUrl: string = MEAL_SERVICE_API_PREFIX + "/meal/getMeals";

export default class RamsayApis implements IRamsayApis {
    getFoodGroups(): Promise<IFoodCategory[]> {
        return ApiUtils.apiGetRequest(foodGroupsUrl);
    }

    fetchMealsByCalorieBreakup(calorieBreakup: IFetchMealsByCaloriesRequest): Promise<IMealItem[]> {
        return ApiUtils.apiPostRequest(fetchMealsByCalorieUrl, JSON.stringify(calorieBreakup))
    }

    getMealByMealId(mealId: string): Promise<IMealItem> {
        return ApiUtils.apiGetRequest(getMealByMealId.replace("$mealId", mealId))
    }

    previewMeal(meal: IMealItem): Promise<IMealItem> {
        return ApiUtils.apiPostRequest(previewMeal, JSON.stringify(meal))
    }

    createMeal(meal: IMealItem): Promise<IMealItem> {
        return ApiUtils.apiPostRequest(createMeal, JSON.stringify(meal))
    }

    getMealsByMealIds(ids: string[]): Promise<IMealItem[]> {
        return ApiUtils.apiPostRequest(getMealsByIdsUrl, JSON.stringify({mealIds: ids}))
    }
}